import { ReadOnlyField } from '@app/components/various/Fields/ReadOnlyField';
import { FieldLabel, FormGrid } from '@app/components/various/Form';
import { isDefined } from '@app/utils/is';
import { useTranslation } from 'react-i18next';

import { Lookbook } from '../../../../typings';

interface Props {
  isLoading?: boolean;
  accountRequestDetails?: Lookbook.AccountRequestDetailsResponse;
}

export const AccountRequestInformation = ({ accountRequestDetails, isLoading }: Props) => {
  const { t } = useTranslation(['accounts', 'common']);

  return (
    <>
      <section className="box mt-4">
        <h3 className="mb-4 heading-3">{t('accounts:account_information')}</h3>
        <FormGrid cols={2} colGap="xlarge">
          <FieldLabel label={t('common:company_name')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.company}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:email')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.email}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:first_name')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.firstName}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:last_name')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.lastName}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:country')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.countryName}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:mobile')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.mobileNumber}</ReadOnlyField>
          </FieldLabel>
        </FormGrid>
      </section>
      <section className="box mt-4">
        <h3 className="mb-4 heading-3">{t('accounts:more_account_information')}</h3>
        <FormGrid cols={2} colGap="xlarge">
          <FieldLabel label={t('common:address')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.address}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:address_continued')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.address2}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:city')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.city}</ReadOnlyField>
          </FieldLabel>
          {isDefined(accountRequestDetails?.stateName) && (
            <FieldLabel label={t('common:state')}>
              <ReadOnlyField isLoading={isLoading}>{accountRequestDetails.stateName}</ReadOnlyField>
            </FieldLabel>
          )}
          <FieldLabel label={t('common:zip_code')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.zipcode}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:vat_number')}>
            <ReadOnlyField isLoading={isLoading}>{accountRequestDetails?.taxId}</ReadOnlyField>
          </FieldLabel>
          <FieldLabel label={t('common:additional_info')}>
            <ReadOnlyField isLoading={isLoading} multiline>
              {accountRequestDetails?.message}
            </ReadOnlyField>
          </FieldLabel>
        </FormGrid>
      </section>
    </>
  );
};
